import React from "react";
import * as Icons from "lucide-react";
import { ArrowRight } from "lucide-react";

// Объединённый массив: сильные тезисы из "Решения" и "Почему мы" без дублей
const cards = [
  {
    icon: "Award",
    title: "Опытные врачи с регалиями",
    text: "Команда специалистов с дипломами и подтверждённым опытом имплантации.",
    accent: false,
  },
  {
    icon: "Microscope",
    title: "Новейшее оборудование",
    text: "КТ, операционный микроскоп, хирургические шаблоны — для максимальной точности.",
    accent: false,
  },
  {
    icon: "ShieldCheck",
    title: "Пожизненная гарантия на имплант",
    text: "Инвестиция в ваше здоровье на десятки лет вперёд.",
    accent: false,
  },
  {
    icon: "Sparkles",
    title: "3D-моделирование улыбки",
    text: "Вы увидите идеальный результат ещё до начала лечения.",
    accent: false,
  },
  {
    icon: "Moon",
    title: "Лечение под седацией",
    text: "По показаниям — медикаментозный сон под контролем анестезиолога.",
    accent: false,
  },
  {
    icon: "CreditCard",
    title: "Беспроцентная рассрочка",
    text: "До 24 месяцев без переплат — оформим в клинике за 15 минут.",
    accent: false,
  },
  {
    icon: "Beaker",
    title: "Своя зуботехническая лаборатория",
    text: "Изготавливаем коронки и протезы без посредников — быстрее и точнее.",
    accent: false,
  },
  {
    icon: "HeartHandshake",
    title: "Персональный куратор",
    text: "Поможем с проживанием, вызовем такси, ответим на любой вопрос — 24/7.",
    accent: true, // выделенная бирюзовая плашка
  },
];

export default function WhyUs() {
  return (
    <section className="whyus" id="usp" data-testid="whyus-section">
      <div className="container">
        <div className="solution-head">
          <div>
            <div className="section-label">Почему мы</div>
            <h2 className="section-title">
              Имплантация — <span className="accent-teal">полное восстановление</span> с комфортом и предсказуемым результатом
            </h2>
          </div>
          <p className="section-subtitle section-subtitle-accent" style={{ marginBottom: 0 }}>
            От первой консультации до постоянной коронки — вы окружены заботой. Передовые технологии, опытные врачи и прозрачные цены в одной клинике.
          </p>
        </div>

        <div className="whyus-content">
          <div className="whyus-photo">
            <img src="/clinic/whyus-team.jpg" alt="Врачи клиники во время приёма пациента" loading="lazy" />
          </div>

          <div className="whyus-grid">
            {cards.map((c) => {
              const Icon = Icons[c.icon] || Icons.Star;
              return (
                <div key={c.title} className={`benefit-card ${c.accent ? "benefit-card-accent" : ""}`} data-testid={`whyus-${c.icon}`}>
                  <div className="benefit-icon">
                    <Icon size={24} strokeWidth={1.8} />
                  </div>
                  <div className="benefit-title">{c.title}</div>
                  <p className="benefit-text">{c.text}</p>
                </div>
              );
            })}
          </div>
        </div>

        <div className="usp-cta">
          <a href="#final" className="btn btn-primary" data-testid="whyus-cta">
            Записаться на консультацию
            <ArrowRight size={18} />
          </a>
        </div>
      </div>
    </section>
  );
}
